<template>
    <div class="d-select">
        <div v-if="label" :for="label" class="copy-s bold label">{{ label }}</div>
        <div ref="select" :class="{ open: open }" class="select-container">
            <div
                :title="currentValue || placeholder"
                class="button-container"
                tabindex="0"
                @click="toggleSelect"
                @keypress.enter="open = true"
            >
                <div class="text copy-m bold">{{ currentValue ? currentValue.text : placeholder }}</div>
                <FeatherIcon name="chevron-down" />
            </div>
            <div class="dropdown-container">
                <div
                    v-for="val in options"
                    :key="val.value"
                    :ref="'option-' + val.value"
                    :title="val.text"
                    :class="['option', value === val.value ? 'currently_selected' : '']"
                    :tabindex="open ? 0 : -1"
                    :value="val.value"
                    @keyup.enter="open = false"
                    @click="select(val.value)"
                >
                    <div class="text copy-m">
                        {{ val.text }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FeatherIcon from '@/components/FeatherIcon'
export default {
    name: 'Select',
    components: {
        FeatherIcon,
    },
    introduction: 'The Select component of Dokedu',
    description: '',
    token: '<DSelect value="Value" mode="default" :options="[{value: 1, text: \'This is the first option\'},{value: 2, text: \'guess what second option\'}]"/>',
    props: {
        mode: {
            type: String,
            default: 'default',
            note: 'the mode of the select (search | default)',
        },
        options: {
            type: Array,
            default: () => [],
            note: 'the options of the select as an Object {key->value}',
        },
        label: {
            type: String,
            default: '',
            note: 'the label shown above the select',
        },
        placeholder: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '',
            note: 'the current value',
        },
    },
    data() {
        return {
            open: false,
        }
    },
    computed: {
        currentValue() {
            return this.options.find((a) => a.value === this.value)
        },
    },
    mounted() {
        window.addEventListener('click', this.autoClose)
        // window.addEventListener('keydown', this.keydown);
    },
    beforeDestroy() {
        window.removeEventListener('click', this.autoClose)
        // window.removeEventListener('keydown', this.keydown);
    },
    methods: {
        select(key) {
            // only emit the click even if the type is not disabled
            if (this.type === 'disabled') return
            this.$emit('input', key)
            this.open = false
        },
        toggleSelect() {
            this.open = !this.open
        },
        autoClose(e) {
            if (!e.composedPath().includes(this.$refs['select'])) this.open = false
        },
        keydown(e) {
            if (this.open && (e.code === 'ArrowDown' || e.code === 'ArrowUp')) {
                e.preventDefault()

                let optionKeys = Object.keys(this.options)
                let nextKey = optionKeys.indexOf(this.value) + (e.code === 'ArrowDown' ? 1 : -1)
                if (nextKey === optionKeys.length) nextKey = 0
                if (nextKey === -1) nextKey = optionKeys.length - 1

                let next = optionKeys[nextKey]
                this.$emit('input', next)
            }
        },
    },
}
</script>

<style scoped lang="sass">
.d-select

    .label
        margin-bottom: $xxs

    .select-container
        position: relative

        .button-container
            background: $gray-2
            display: flex
            align-items: center
            justify-content: space-between
            height: $xl
            padding: 0 $s
            border:
                radius: 5px

            &:focus
                outline: none


            &:hover
                cursor: pointer

            &:focus, &:hover
                .text
                    color: $primary-2

            &:active
                background: darken($neutral-1, 5%)

            .text
                white-space: nowrap
                width: 100%
                overflow: hidden
                text-overflow: ellipsis

        .dropdown-container
            background: white
            padding: $s $xxs
            min-width: 0
            position: absolute
            top: 4rem
            box-shadow: $box-mois
            border:
                radius: 5px
            transform: translate(0, -20px)
            opacity: 0
            +transition(100ms)
            pointer-events: none
            z-index: 3
            width: 100%
            box-sizing: border-box

            .option
                display: flex
                min-width: 0
                align-items: center
                height: 3.2rem
                padding: 0 $s
                border:
                    radius: 5px

                &.currently_selected
                    .text
                        color: $primary-2
                        font-weight: bold

                &:focus
                    outline: none
                    box-shadow: 0 0 0 2px $primary-2


                &:hover
                    background: $gray-1
                    cursor: pointer

                &:not(:last-child)
                    margin-bottom: $xxs

                .text
                    text-overflow: ellipsis
                    overflow: hidden
                    white-space: nowrap

        &.open
            .button-container
                box-shadow: $box-mois
                box-shadow: 0 0 0 1px $primary-2

            .dropdown-container
                transform: translate(0, 0px)
                opacity: 1
                pointer-events: all
</style>
